/**
 * Created by vladislav on 7/9/2025
 */

const PushHelper = {
    started: false,
    queue: {},

    sendPush: function (push, timeout) {
        if (connector.platform.oneOf(connector.DISCORD)
            && [PUSHES.WELCOME,
                PUSHES.ORDER_READY,
                PUSHES.BUILDING_BUILT].indexOf(push) === -1) {
            return;
        }

        if (!this.started) {
            this.queue[push.id] = { action: "send", push, timeout };
            return;
        }

        connector.notifications.send(this._localizePush(push), timeout);
    },

    cancelPush: function (push) {
        if (!this.started) {
            this.queue[push.id] = { action: "cancel", push };
            return;
        }

        connector.notifications.cancel(push.id);
    },

    start: function () {
        this.started = true;

        for (const { action, push, timeout } of Object.values(this.queue)) {
            if (action === "send") {
                this.sendPush(push, timeout);
            } else {
                this.cancelPush(push);
            }
        }

        this.queue = {};
    },

    _localizePush: function (push) {
        let message = Messages.get(push.message);
        let title = Messages.get(push.title, {
            gameTitle: Messages.get(cleverapps.config.name)
        });

        if (!Array.isArray(message)) {
            message = [message];
        }
        if (!Array.isArray(title)) {
            title = [title];
        }

        const index = Math.floor(Math.random() * message.length);
        const titleIndex = Math.floor(Math.random() * title.length);

        return {
            ...push,
            message: message[index],
            title: title[index] || title[titleIndex]
        };
    }
};